import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Thumbnail from 'components/Thumbnail';

import Icon from 'components/Icon';
import styles from './styles.module.scss';

const labelThemeMapping = {
	premiere: { label: 'Премьера' },
	lastWeek: { label: 'Последняя неделя' }
};

const BaseCard = ({
	title,
	date,
	organization,
	place,
	location,
	description,
	url,
	badgeType,
	thumbnailFile,
	thumbnailParams,
	preloadImage,
	ageRestriction,
	placeholderIcon,
	type,
	showLink,
	foundationDate,
	isSlider
}) => (
	<a
		href={url}
		target="_blank"
		className={cx(styles.BaseCard, {
			[styles.BaseCard_withAge]: !!ageRestriction && !!thumbnailFile,
			[styles.BaseCard_noImage]: !thumbnailFile,
			[styles.BaseCard_slider]: isSlider
		})}
	>
		<div className={styles.BaseCard__Head}>
			<Thumbnail
				file={thumbnailFile}
				params={thumbnailParams}
				preloadImage={preloadImage}
				placeholderIcon={placeholderIcon}
				keepRatio
			/>
			{ageRestriction ? (
				<div className={styles.BaseCard__Age}>{`${ageRestriction}+`}</div>
			) : null}
			{badgeType ? (
				<div className={styles.BaseCard__Label}>
					<span className={styles.BaseCard__LabelText}>
						{labelThemeMapping[badgeType]?.label}
					</span>
				</div>
			) : null}
		</div>
		<div
			className={cx(styles.BaseCard__Body, styles[`BaseCard__Body_${type}`])}
		>
			<div className={styles.BaseCard__Title}>{title}</div>
			{date && <div className={styles.BaseCard__Date}>{date}</div>}
			{organization && (
				<div className={styles.BaseCard__Organization}>
					<div>Организатор:</div>
					<div className={styles.BaseCard__PlaceText}>{organization}</div>
				</div>
			)}
			{place && (
				<div className={styles.BaseCard__Place}>
					<div>Место проведения:</div>
					<span className={styles.BaseCard__PlaceText}>{place}</span>
				</div>
			)}
			{location && <div className={styles.BaseCard__Location}>{location}</div>}
			{foundationDate && (
				<div className={styles.BaseCard__FoundationDate}>{foundationDate}</div>
			)}
			{description && (
				<div className={styles.BaseCard__Description}>{description}</div>
			)}
			{showLink ? (
				<div className={styles.BaseCard__Link}>
					Узнать подробнее
					<Icon icon="arrowRight" className={styles.BaseCard__LinkIcon} />
				</div>
			) : null}
		</div>
	</a>
);

BaseCard.propTypes = {
	title: PropTypes.string.isRequired,
	date: PropTypes.string,
	organization: PropTypes.string,
	place: PropTypes.string,
	location: PropTypes.string,
	description: PropTypes.string,
	url: PropTypes.string,
	badgeType: PropTypes.oneOf(['premiere', 'lastWeek']),
	thumbnailFile: PropTypes.object,
	thumbnailParams: PropTypes.object,
	preloadImage: PropTypes.bool,
	ageRestriction: PropTypes.number,
	placeholderIcon: PropTypes.string,
	type: PropTypes.oneOf(['institute', 'event']),
	showLink: PropTypes.bool,
	foundationDate: PropTypes.string,
	isSlider: PropTypes.bool
};

BaseCard.defaultProps = {
	preloadImage: false,
	showLink: true
};

export default BaseCard;
